import { __ } from "@wordpress/i18n";
import { registerBlockType } from "@wordpress/blocks";

import { Map, Marker } from "../../components/Map"
import Resizable from "../../components/Resizable"
import Inspector from "./components/Inspector"
import providers from './../../shared/providers';
const { Placeholder, SelectControl } = wp.components;
import icons from "../../../../../icons.js";
import store from "../../../../../store";

/**
 * Source : https://github.com/goiblas/Map-Block-Leaflet.
 */
export default registerBlockType(  'wp-apidae/single-maps', {
	title:__('Carte fiche Apidae'),
	description: __('Affiche la localisation de la fiche sur une carte', 'wp-apidae'),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.map
	},
	supports: {
			html: false,
	align: ['wide', 'full']
},
attributes: {
	height: {
		type: "number",
		default: 250,
	},
	height_percent: {
		type: "number",
		default: 100,
	},
	height_type: {
		type: "string",
		default: 'px',
	},
	lat: {
		type: "number",
		default: 43.644118379952,
	},
	lng: {
		type: "number",
		default: 5.599848912523872,
	},
	zoom: {
		type: "number",
		default: 15,
	},
	themeId: {
		type: 'number',
		default: providers[0].id
},
themeUrl: {
		type: 'string',
		default: providers[0].url
},
themeAttribution: {
		type: 'string',
		default: providers[0].attribution
},
show_gpx: {
	type: "boolean",
	default: false,
},
},
	edit: props => {
			const {attributes, setAttributes, toggleSelection } = props;
			const position = [attributes.lat, attributes.lng];

			const handleZoom = ( zoom ) =>  setAttributes({ zoom })
			const handleHeight = ( height ) =>  setAttributes({ height })
			
			return (
					<> 
					<Inspector {...props}/>
						<Resizable 
								height={ attributes.height}
								setHeight={ handleHeight }
								toggleSelection={toggleSelection}
								>
								<Map 
										disableScrollZoom={attributes.disableScrollZoom}
										position={position}
										zoom={attributes.zoom}
										themeUrl={attributes.themeUrl}
										height={attributes.height}
										setZoom={handleZoom}
										>
								</Map>
						</Resizable>
							</>
			)
	},
	save: () => null
});